import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { Col, Container, Row } from 'reactstrap';

//Import Icons
import FeatherIcon from 'feather-icons-react';

// Import Images
import ImageMyWords from '../../assets/images/v3/my_words.png';
import ImageDiscover from '../../assets/images/v3/discover.png';
import ImageQuiz from '../../assets/images/v3/quiz.png';
import ImageChrome from '../../assets/images/chrome.png';
import ImageFirefox from '../../assets/images/firefox.png';
import ImageEdge from '../../assets/images/edge.png';
import ImageAppStore from '../../assets/images/app_store_badge_564x168.png';
import ImageGooglePlay from '../../assets/images/google_play_badge_trimmed_564x168.png';

// Modal Video
import ModalVideo from 'react-modal-video';
import '../../../node_modules/react-modal-video/scss/modal-video.scss';

const Section = () => {
  const [open, setOpen] = useState(false);
  const [videoId, setVideoId] = useState('');

  const openModal = (id) => {
    setVideoId(id);
    setOpen(true);
  };

  return (
    <React.Fragment>
      <section
        className="bg-half-170 border-bottom agency-wrapper d-table w-100"
        id="home"
      >
        <Container>
          <Row className="align-items-center">
            <Col lg={7} md={7} className="order-1 order-md-2">
              <div className="title-heading mt-4 ms-lg-5">
                <h1 className="heading mb-3">
                  Learn English Vocabulary{' '}
                  <span className="text-primary">While You Browse</span>
                </h1>
                <p className="para-desc text-muted">
                  HighVocab is a browser extension for English learners. Save
                  new words instantly, review them in context, and build a
                  vocabulary that actually sticks.
                </p>
                {/* Browser extension group */}
                <p style={{ fontSize: '0.72rem', fontWeight: 700, letterSpacing: '0.09em', textTransform: 'uppercase', color: '#94a3b8', margin: '20px 0 8px' }}>
                  Browser Extension
                </p>
                <div className="d-flex flex-wrap gap-2">
                  <a href="https://chrome.google.com/webstore/detail/highvocab-vocabulary-buil/nmalijlbcckplnamalenpdaafacfeemd?hl=en" target="_blank" rel="noreferrer" className="btn btn-primary d-inline-flex align-items-center" style={{ gap: 8 }}>
                    <img src={ImageChrome} style={{ width: 20, height: 20 }} alt="" />
                    Install on Chrome
                  </a>
                  <a href="https://microsoftedge.microsoft.com/addons/detail/highvocab-vocabulary-bui/dfpolnmicooilcndegandafkmooecmei" target="_blank" rel="noreferrer" className="btn btn-primary d-inline-flex align-items-center" style={{ gap: 8 }}>
                    <img src={ImageEdge} style={{ width: 20, height: 20 }} alt="" />
                    Install on Edge
                  </a>
                  <a href="https://addons.mozilla.org/en-US/firefox/addon/highvocab-vocabulary-builder/" target="_blank" rel="noreferrer" className="btn btn-primary d-inline-flex align-items-center" style={{ gap: 8 }}>
                    <img src={ImageFirefox} style={{ width: 20, height: 20 }} alt="" />
                    Install on Firefox
                  </a>
                </div>

                {/* Mobile app group */}
                <p style={{ fontSize: '0.72rem', fontWeight: 700, letterSpacing: '0.09em', textTransform: 'uppercase', color: '#94a3b8', margin: '18px 0 8px' }}>
                  Mobile App
                </p>
                <div className="d-flex align-items-center flex-wrap gap-2">
                  <a href="https://apps.apple.com/us/app/highvocab/id6770623659" target="_blank" rel="noreferrer" style={{ display: 'inline-block', lineHeight: 0 }}>
                    <img src={ImageAppStore} alt="Download on the App Store" style={{ height: 42, width: 'auto' }} />
                  </a>
                  <a href="https://play.google.com/store/apps/details?id=com.highvocab.app" target="_blank" rel="noreferrer" style={{ display: 'inline-block', lineHeight: 0 }}>
                    <img src={ImageGooglePlay} alt="Get it on Google Play" style={{ height: 42, width: 'auto' }} />
                  </a>
                </div>

                {/* Video links */}
                <div className="d-flex flex-wrap gap-3 mt-4">
                  <div className="d-flex align-items-center gap-2">
                    <Link to="#" onClick={() => openModal('ccO9w6J8MeE')} className="btn btn-icon btn-pills btn-primary lightbox">
                      <FeatherIcon icon="video" className="icons" />
                    </Link>
                    <span className="fw-bold text-uppercase small">How to use</span>
                  </div>
                </div>
              </div>

              <ModalVideo
                channel="youtube"
                isOpen={open}
                videoId={videoId}
                onClose={() => setOpen(false)}
              />
            </Col>
            <Col
              lg={5}
              md={5}
              className="order-2 order-md-1 mt-4 pt-2 mt-sm-0 pt-sm-0 d-none d-md-flex align-items-center justify-content-center"
            >
              <div style={{ position: 'relative', width: 300, height: 420 }}>
                {/* Back-left: Discover */}
                <div style={{
                  position: 'absolute',
                  left: 0,
                  top: 30,
                  width: 160,
                  transform: 'rotate(-6deg)',
                  borderRadius: 20,
                  overflow: 'hidden',
                  boxShadow: '0 16px 40px rgba(15,23,42,0.14)',
                  border: '1px solid rgba(15,23,42,0.06)',
                  zIndex: 1,
                }}>
                  <img src={ImageDiscover} alt="Discover words" style={{ width: '100%', display: 'block' }} />
                </div>

                {/* Back-right: Quiz */}
                <div style={{
                  position: 'absolute',
                  right: 0,
                  top: 50,
                  width: 155,
                  transform: 'rotate(5deg)',
                  borderRadius: 20,
                  overflow: 'hidden',
                  boxShadow: '0 16px 40px rgba(15,23,42,0.12)',
                  border: '1px solid rgba(15,23,42,0.06)',
                  zIndex: 1,
                }}>
                  <img src={ImageQuiz} alt="Quiz yourself" style={{ width: '100%', display: 'block' }} />
                </div>

                {/* Front-center: My Words */}
                <div style={{
                  position: 'absolute',
                  left: '50%',
                  top: 0,
                  transform: 'translateX(-50%)',
                  width: 175,
                  borderRadius: 22,
                  overflow: 'hidden',
                  boxShadow: '0 24px 60px rgba(15,23,42,0.2)',
                  border: '1px solid rgba(15,23,42,0.07)',
                  zIndex: 2,
                }}>
                  <img src={ImageMyWords} alt="My word list" style={{ width: '100%', display: 'block' }} />
                </div>
              </div>
            </Col>
          </Row>
        </Container>
      </section>
    </React.Fragment>
  );
};

export default Section;
